<script lang="ts" setup>
defineProps<{
  active: number;
  total: number;
}>();

const emit = defineEmits<{
  (e: "prev"): void;
  (e: "next"): void;
}>();
</script>

<template>
  <div class="flex items-center justify-center mt-2 gap-3">
    <button
      :disabled="active === 0"
      class="btn btn-xs rounded btn-neutral btn-square"
      @click="emit('prev')"
    >
      <i class="iconify mingcute--left-line" />
    </button>
    <div class="flex items-center justify-center gap-1">
      <i
        v-for="(i, idx) in total"
        :key="i"
        :class="{
          'bg-base-content': idx === active,
          'bg-neutral': idx !== active,
        }"
        class="w-2 rounded-full h-2 inline-block"
      />
    </div>
    <button
      :disabled="active === total - 1"
      class="btn btn-xs rounded btn-neutral btn-square"
      @click="emit('next')"
    >
      <i class="iconify mingcute--right-line" />
    </button>
  </div>
</template>
